import { z } from 'zod';
import { latSchema, lonSchema, pointSchema } from './commun';
import { filtresSchema } from './filtres';
import { clientProcheSchema } from './proches';

/** Bornes du périmètre en km autour d'un point posé sur la carte, et valeur par défaut. */
export const RAYON_KM_MIN = 1;
export const RAYON_KM_MAX = 50;
export const RAYON_KM_DEFAUT = 5;
/** Nombre maximal de clients renvoyés (le portefeuille complet fait environ 210 clients). */
export const LIMITE_RAYON = 500;

/**
 * Paramètres de `GET /api/clients/rayon` : les filtres de la carte (sauf la boîte), le centre et
 * le rayon en km. Les noms `lon` et `lat` sont imposés : ce sont eux que le journal masque.
 */
export const clientsRayonRequeteSchema = filtresSchema.omit({ bbox: true }).extend({
  lon: lonSchema,
  lat: latSchema,
  rayon_km: z.coerce.number().min(RAYON_KM_MIN).max(RAYON_KM_MAX).default(RAYON_KM_DEFAUT),
});
export type ClientsRayonRequete = z.infer<typeof clientsRayonRequeteSchema>;

export const clientsRayonReponseSchema = z.object({
  centre: pointSchema,
  /** Rayon appliqué, en km. */
  rayonKm: z.number(),
  /** Distances à vol d'oiseau, durées estimées (SPEC 4, règle 8). */
  dureesEstimees: z.literal(true),
  /** Vrai quand plus de `LIMITE_RAYON` clients sont dans le rayon : seuls les plus proches sont renvoyés. */
  tronque: z.boolean(),
  /** Clients triés par distance croissante. */
  clients: z.array(clientProcheSchema),
});
export type ClientsRayonReponse = z.infer<typeof clientsRayonReponseSchema>;
